import { render, staticRenderFns } from "./ProfilLinks.vue?vue&type=template&id=087d068c"
import script from "./ProfilLinks.vue?vue&type=script&lang=js"
export * from "./ProfilLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports